// Do NOT add "use client" to this file
import {
  getDefaultImageUrl,
  getNormalizedImageUrls,
} from "@faire/deprecated-retailer-visitor-shared/components/Image/ProgressiveProductImage";
import { ImageOverlay } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ImageOverlay";
import { VERTICAL_ASPECT_RATIO } from "@faire/deprecated-retailer-visitor-shared/lib/verticalAspectRatio";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import * as React from "react";
import { preload } from "react-dom";

export const ProductImageWithSrcsetSizes = ({
  image,
  alt,
  sizes,
  showVerticalImagery,
  formattedExtraProductsCount,
  smallCount,
  loading,
  preload: shouldPreload = true,
  onLoad,
  addOverlay = true,
  objectFit,
}: {
  image: IImage;
  alt: string;
  sizes: string;
  showVerticalImagery?: boolean;
  formattedExtraProductsCount?: string;
  smallCount?: boolean;
  loading?: HTMLImageElement["loading"];
  preload?: boolean;
  onLoad?: () => void;
  addOverlay?: boolean;
  objectFit?: string;
}) => {
  const dataTestId = `product-image${showVerticalImagery ? "-vertical" : ""}`;
  const normalizedUrls = getNormalizedImageUrls(image, showVerticalImagery, {});

  const src = getDefaultImageUrl(image, showVerticalImagery, {});

  if (shouldPreload) {
    preload(src, { as: "image" });
  }
  const aspectRatio = showVerticalImagery ? VERTICAL_ASPECT_RATIO : 1;

  return (
    <picture
      className="rounded-fs-component-default relative flex h-0 w-full shrink-0"
      style={{ paddingTop: `calc(100% / ${aspectRatio})` }}
      data-test-id={dataTestId}
    >
      <source srcSet={normalizedUrls} sizes={sizes} />
      <img
        className={`absolute top-0 left-0 h-full w-full object-center object-${objectFit ? objectFit : "cover"} rounded-fs-component-default`}
        src={src}
        alt={alt}
        loading={loading}
        onLoad={onLoad}
      />
      {addOverlay ? (
        <ImageOverlay
          formattedExtraProductsCount={formattedExtraProductsCount}
          smallCount={smallCount}
        />
      ) : null}
    </picture>
  );
};
